<template>
  <v-container>
    <h1>Welcome to use DP-GUI</h1>
  </v-container>
</template>
